import {Pipe, PipeTransform} from "@angular/core";
import {UtilitiesService} from "../../core/_services/utilities.service";
import {EcommerceProduct} from "../_models/ecommerce-product";
import {Service} from "../_models/service";

@Pipe({
    name: 'ecommerceProducts'
})
export class EcommerceProductsPipe implements PipeTransform {

    transform(services: Service[]): EcommerceProduct[] {
        if (UtilitiesService.isEmpty(services)) {
            return [];
        }

        const products: EcommerceProduct[] = [];
        for (let service of services) {
            products.push({
                'id': service.productId,
                'name': service.name,
                'quantity': 1
            });
        }
        return products;
    } // transform()

} // EcommerceProductsPipe
